import { z } from 'zod';

import { passwordSchema } from '@/features/auth/validation/password.schema';

export const updatePasswordInputSchema = z
  .object({
    currentPassword: z.string().min(1, { message: 'required' }),
    newPassword: passwordSchema,
    newPasswordConfirmation: z.string({
      error: 'required',
    }),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirmation, {
    message: 'do_not_match',
    path: ['newPasswordConfirmation'],
  });

export type UpdatePasswordInput = z.infer<typeof updatePasswordInputSchema>;

export const resetPasswordNewSchema = z
  .object({
    newPassword: passwordSchema,
    newPasswordConfirmation: z.string({
      error: 'required',
    }),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirmation, {
    message: 'do_not_match',
    path: ['newPasswordConfirmation'],
  });

export type ResetPasswordNewInput = z.infer<typeof resetPasswordNewSchema>;
